import YadavBhattarai from "../media/ManagementTeam/YADAV BHATTARAI.png";
import UdeshKhadka from "../media/ManagementTeam/UDESH KHADKA.png";
import KoshrajPokhrel from "../media/ManagementTeam/KOSHRAJ POKHREL.png";
import RamPrasadPandey from "../media/ManagementTeam/RAM PRASAD PANDEY.png";
import LokendraSotiMagar from "../media/ManagementTeam/LOKENDRA SOTI MAGAR.png";
import SushmitaKhatri from "../media/ManagementTeam/SUSMITA KHATRI.png";
import AnitaGautam from "../media/ManagementTeam/ANITA GAUTAM.png";
import JibanNeupane from "../media/ManagementTeam/ADV.JIBAN NEUPANE.png";
import DineshKKhadka from "../media/ManagementTeam/DineshKKhadka.png";
import male from "../media/ManagementTeam/male.png";
import DhirendraPant from "../media/ManagementTeam/DHIRENDRAPANT.jpg";
import AshishKarn from "../media/ManagementTeam/ASHISHKARN.png";

export const managementTeam = [
//   {
//     name: 'Yadav Bhattarai',
//     src: YadavBhattarai,
//     id: 'YadavBhattarai',
//     title: 'Chairperson',
//     address: 'Syangja',
//     bio: `I am a business professional with over a decade of experience in the dynamic fields of trading,
// investment, hospitality and agriculture. My deep understanding of market trends, coupled with
// strategic acumen, has enabled me to achieve significant success in these sectors.`,
//     email: 'ybh.brahmajyoti@gmail.com'
//   },
  {
    name: 'Dinesh Kumar Khadka',
    src: DineshKKhadka,
    id: 'DineshKhadka',
    title: 'CEO',
    address: 'Dolakha, Nepal',
    bio: `I am a dynamic, results-driven professional with more than two decades of progressive leadership and management experience across operations management, human resource, talent development, logistics, administration and investment advisory.`,
    email: 'dkk.brahmajyoti@gmail.com'
  },
  {
    name: "Dhirendra Pant",
    src: DhirendraPant,
    id: "DhirendraPant",
    title: "Director, Public Relations",
    address: "Kathmandu, Nepal",
    bio: `Mr. Dhirendra Pant is a visionary leader in Nepal’s banking and remittance ecosystem, with over 27 years of experience across Nepal and the Gulf region. His career spans banking, remittance services, and financial consultancy, giving him a unique perspective on transforming remittance flows into long-term national assets.
Driven by a strong belief in investing wealth into productive sectors such as hydropower, tourism, agriculture, health, education, and skill development, Mr. Pant champions a development model focused on employment generation, self-reliance, and sustainable entrepreneurship. As a strategic think tank contributor, he has actively advised government ministers and senior policymakers, including the proposal of a “Nepali Migrants’ Remittance Board” to channel migrant earnings into nation-building initiatives.
His vision centers on empowering youth, mobilizing migrant capital, and bridging the government, private, and global Nepali community to build a resilient, inclusive, and self-reliant Nepal.`,
   email: "dhirendra.brahmajyoti@gmail.com"
  },
    {
    name: "Ashish Karn",
    src: AshishKarn,
    id: "DhirendraPant",
    title: "Admin and Finance Officer",
    address: "Rautahat, Nepal",
    bio: `Strategic finance and operations professional with 5+ years driving growth in startup environments through analytical, cross-functional leadership and innovative solutions.`,
   email: " ashish.brahmajyoti@gmail.com"
  },
  // {
  //   name: 'Koshraj Pokhrel',
  //   src: KoshrajPokhrel,
  //   id: 'KoshrajPokhrel',
  //   title: 'Director',
  //   address: 'Dang',
  //   bio: `I am an accomplished professional with over 10 years of expertise in investment and trade.`,
  //   email: 'krp.brahmajyoti@gmail.com'
  // },
  // {
  //   name: 'Ram Prasad Pandey',
  //   src: RamPrasadPandey,
  //   id: 'RamPrasadPandey',
  //   title: 'Managing Director',
  //   address: 'Nawalparasi',
  //   bio: `I am a savant entrepreneur and strategic thinker with over 12 years of experience spanning administration, marketing, finance, and the stock market.`,
  //   email: 'rpp.brahmajyoti@gmail.com'
  // },
  // {
  //   name: 'Susmita Khatri',
  //   src: SushmitaKhatri,
  //   id: 'SusmitaKhatri',
  //   title: 'Director',
  //   address: 'Dolakha',
  //   bio: `I am a dedicated professional with over six years of experience in administration and human resources management.`,
  //   email: 'susmita.brahmajyoti@gmail.com'
  // },
  // {
  //   name: 'Anita Gautam',
  //   src: AnitaGautam,
  //   id: 'AnitaGautam',
  //   title: 'Director',
  //   address: 'Kavrepalanchowk',
  //   bio: `I am a distinguished professional with over seven years of experience in stock trading, portfolio management, and the hotel and tourism sector.`,
  //   email: 'anita.brahmajyoti@gmail.com'
  // },
  // {
  //   name: 'Lokendra Soti Magar',
  //   src: LokendraSotiMagar,
  //   id: 'LokendraSotiMagar',
  //   title: 'Director',
  //   address: 'Nawalparasi',
  //   bio: `I am a dynamic Professional in Global Trade and Hospitality with over a decade of experience.`,
  //   email: 'lsm.brahmajyoti@gmail.com'
  // },
  {
    name: 'Jiban Neupane',
    src: male,
    id: 'JibanNeupane',
    title: 'Secretary',
    address: 'Kathmandu',
    bio: `I am a tenacious corporate lawyer with over a decade of experience in navigating complex legal landscapes.`,
    email: 'jiban.brahmajyoti@gmail.com'
  }
];

export const testimonials: Record<string, string> = {
  UdeshKhadka: `Dear Valued Investors and Clients,

We extend our heartfelt gratitude to each of you for your continued trust and support. Your confidence in our vision and strategy inspires us to achieve greater heights as we work towards delivering sustained growth and value creation.

At Brahma Jyoti Holdings Limited (BJHL), we remain steadfast in our commitment to: Transparency, Innovation and Sustainability.

Thank you once again for your partnership and trust in Brahma Jyoti Holdings Limited. Please feel free to reach out for any inquiries or updates—we value your feedback and collaboration.

Warm regards,

Udesh Khadka
CEO/BOD
Brahma Jyoti Holdings Limited`,

  YadavBhattarai: `

I am pleased to reflect on our continued progress and the successful expansion of our holdings company into diverse sectors, including equities, agriculture, and financial consultancy.

As we look to the future, we remain committed to diversifying our portfolio further, enhancing operational efficiencies, and maintaining a clear focus on generating long-term value for our stakeholders.

`,

  JibanNeupane: `

As the Company Secretary for Brahma Jyoti Holdings Limited, my primary responsibility is to ensure that we operate within the framework of applicable laws and regulations. From overseeing compliance to managing filings and advising the board on corporate governance, I work closely with our legal and financial teams to safeguard the company’s interests.
`,
DhirendraPant: `
With over 27 years of experience across Nepal and the Gulf in banking, remittance, and consultancy, I vision to channel youth skills and financial resources into productive enterprises is both timely and practical. My advocacy for establishing a Nepali Migrants Remittance Board offers a strategic framework to mobilize remittance capital into national development priorities.
Such an initiative can bridge the government, public and private sectors, and Nepalis abroad—accelerating self-reliance, entrepreneurship, and sustainable economic growth, and positioning Nepal on a clear path toward becoming a developed nation.
`,

  DineshKhadka: `

I am a dynamic, results-driven professional with more than two decades of progressive leadership and management experience across operations management, human resource, talent development, logistics, administration and investment advisory. I bring a unique blend of strategic insight and high-level financial expertise.`
};

export { projectData } from "./index";

const siteData = {
  managementTeam,
  testimonials,
};

export default siteData;
